import { render, staticRenderFns } from "./KnowledgeCenter.vue?vue&type=template&id=2107d006&scoped=true"
import script from "./KnowledgeCenter.vue?vue&type=script&lang=js"
export * from "./KnowledgeCenter.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/group_dashboard/messages.css?vue&type=style&index=0&id=2107d006&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2107d006",
  null
  
)

export default component.exports